/* 🤖 this file was generated by script */
export const wsolidiconCoinsSwap01 = {
  name: 'coins_swap_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M5.3 1.3a1 1 0 0 1 1.4 0l2 2a1 1 0 0 1 0 1.4l-2 2a1 1 0 0 1-1.4-1.4l.25-.27A3 3 0 0 0 3 8a1 1 0 0 1-2 0 5 5 0 0 1 4.6-4.98l-.3-.31a1 1 0 0 1 0-1.42M18.7 17.3a1 1 0 0 1 0 1.4l-.25.27A3 3 0 0 0 21 16a1 1 0 1 1 2 0 5 5 0 0 1-4.6 4.98l.3.31a1 1 0 0 1-1.4 1.42l-2-2a1 1 0 0 1 0-1.42l2-2a1 1 0 0 1 1.4 0M9.06 7.06a7 7 0 1 1 7.88 7.88 9 9 0 0 0-7.88-7.88"/><path fill="currentColor" d="M8 9a7 7 0 1 0 0 14A7 7 0 0 0 8 9"/></svg>`,
  iconStyle: 'solid',
};
